import { render, staticRenderFns } from "./x-circle.vue?vue&type=template&id=60755265"
import script from "./x-circle.vue?vue&type=script&lang=js"
export * from "./x-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports